<template>
  <div class="parlor-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner">
      <div class="content">
        <h1>产业会客厅</h1>
        <p>与1000+客户一起开启高效产业资源对接，打通产业链上下游，连接政府、企业、资本多方资源，实现共创共赢。</p>
        <div class="actions">
          <el-button class="btn-yellow" type="primary">了解详情</el-button>
          <el-button class="btn-dark" type="primary">&gt;</el-button>
        </div>
      </div>
    </div>

    <!-- 资源展示区域 -->
    <div class="resource-showcase">
      <div class="tab-container">
        <div
            class="tab"
            v-for="(tab, index) in tabs"
            :key="index"
            :class="{ active: activeTabIndex === index }"
            @click="switchTab(index)"
        >
          {{ tab.dictLabel }}
        </div>
      </div>

      <div class="resources-grid">
        <div class="resource-item" v-for="(item, index) in resources" :key="index">
          <div class="resource-image">
            <img :src="item.imageUrl && item.imageUrl.startsWith('http') ? item.imageUrl : imgUrl + item.imageUrl" v-if="item.imageUrl" />
          </div>
          <div class="resource-info">
            <h3>{{ item.title || '' }}</h3>
            <div class="resource-footer">
              <div class="resource-tags">
                <span class="location">{{ item.address || '' }}</span>
                <span class="category">{{ item.industryTagName || '' }}</span>
              </div>
              <div class="resource-action" @click="viewDetail(item.id)">
                <el-button class="btn-detail" type="warning">报名</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 添加分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
        class="pagination">
      </el-pagination>
    </div>

    <!-- 会员加入部分 -->
    <div class="section-join">
      <div class="join-content">
        <h2>加入产业会客厅</h2>
        <el-form class="join-form" :model="joinForm" :rules="joinRules" ref="joinForm">
          <el-input v-model="joinForm.name" placeholder="您的姓名"></el-input>
          <el-input v-model="joinForm.mobile" placeholder="手机号码"></el-input>
          <el-input v-model="joinForm.companyName" placeholder="公司名称"></el-input>
          <el-cascader
              v-model="joinForm.regionArray"
              :options="areaOptions"
              :props="areaProps"
              placeholder="所在地区"
              clearable
              @change="handleAreaChange">
          </el-cascader>
          <el-button class="submit-btn" type="primary" @click="submitJoinForm">提 交</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {saveUserRequirementApi, areaListApi, dictApi, getIndustryLoungeListApi} from '@/api/index';
import {baseImgUrl} from '@/axios/index';

export default {
  name: 'parlorPage',
  data() {
    return {
      imgUrl:baseImgUrl,
      activeTabIndex: 0,
      tabs: [],
      resources: [],
      // 添加分页相关数据
      pageNum: 1,
      pageSize: 6,
      total: 0,
      joinForm: {
        name: '',
        mobile: '',
        companyName: '',
        region: '', // 最终提交的地区编码值
        regionArray: [], // 级联选择器绑定值
        demandType: '6'
      },
      joinRules: {
        name: [
          {required: true, message: '请输入您的姓名', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        companyName: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        region: [
          {required: true, message: '请选择所在地区', trigger: 'change'}
        ]
      },
      areaOptions: [], // 地区选项
      areaProps: {
        value: 'code',
        label: 'label',
        children: 'children',
        checkStrictly: false, // 允许选择任何一级
      }
    }
  },
  created() {
    // 获取地区数据
    this.getAreaList();
    // 获取tabs数据
    this.getTabsData();
  },
  computed: {
    // 移除filteredResources计算属性
  },
  methods: {
    switchTab(index) {
      this.activeTabIndex = index;
      this.pageNum = 1; // 切换标签时重置页码
      this.getResourcesData(this.tabs[index].dictValue);
    },

    // 获取tabs数据
    async getTabsData() {
      try {
        const res = await dictApi('gw_lounge_type');
        if (res && res.data) {
          // 添加全部选项
          const allOption = {
            dictLabel: '全部',
            dictValue: ''
          };
          this.tabs = [allOption, ...res.data];
          // 默认获取全部或第一个类型的数据
          if (this.tabs.length > 0) {
            this.getResourcesData(this.tabs[0].dictValue);
          }
        } else {
          this.$message.error('获取类型列表失败');
        }
      } catch (error) {
        console.error('获取类型列表出错', error);
        this.$message.error('获取类型列表出错');
      }
    },

    // 获取资源列表数据
    async getResourcesData(loungeType) {
      try {
        const params = {
          loungeType: loungeType,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        };
        const res = await getIndustryLoungeListApi(params);
        if (res && res.data) {
          this.resources = res.data.records || [];
          this.total = res.data.total || 0;
        } else {
          this.$message.error('获取会客厅列表失败');
        }
      } catch (error) {
        console.error('获取会客厅列表出错', error);
        this.$message.error('获取会客厅列表出错');
      }
    },

    // 处理每页条数改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.getResourcesData(this.tabs[this.activeTabIndex].dictValue);
    },
    
    // 处理页码改变
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getResourcesData(this.tabs[this.activeTabIndex].dictValue);
    },

    // 获取地区列表数据
    async getAreaList() {
      try {
        const res = await areaListApi();
        if (res && res.data) {
          // 过滤掉level=3的数据，只保留省市两级
          const filteredData = res.data.map(province => {
            // 深拷贝省级数据
            const provinceCopy = JSON.parse(JSON.stringify(province));

            // 处理市级数据，移除区县级
            if (provinceCopy.children && provinceCopy.children.length > 0) {
              provinceCopy.children = provinceCopy.children.map(city => {
                // 移除区县级数据
                const cityCopy = JSON.parse(JSON.stringify(city));
                delete cityCopy.children;
                return cityCopy;
              });
            }

            return provinceCopy;
          });

          this.areaOptions = filteredData;
        } else {
          this.$message.error('获取地区列表失败');
        }
      } catch (error) {
        console.error('获取地区列表出错', error);
        this.$message.error('获取地区列表出错');
      }
    },

    // 地区选择变化处理
    handleAreaChange(value) {
      if (value && value.length > 0) {
        // 使用选中的code作为最终提交的地区编码
        this.joinForm.region = value[1];
      } else {
        this.joinForm.region = '';
      }
    },
    // 报名
    viewDetail(id) {
      const detailUrl = `${window.location.origin}/parlor/detail/${id}`;
      window.open(detailUrl, '_blank');
    },
    submitJoinForm() {
      // 判断字段是否为空
      if (!this.joinForm.name || this.joinForm.name.trim() === '') {
        this.$message.error('请输入您的姓名');
        return;
      }
      if (!this.joinForm.mobile || this.joinForm.mobile.trim() === '') {
        this.$message.error('请输入手机号码');
        return;
      }
      if (!this.joinForm.companyName || this.joinForm.companyName.trim() === '') {
        this.$message.error('请输入公司名称');
        return;
      }
      if (!this.joinForm.region) {
        this.$message.error('请选择所在地区');
        return;
      }

      this.$refs.joinForm.validate(valid => {
        if (valid) {
          saveUserRequirementApi(this.joinForm).then(res => {
            this.$message.success('提交成功');
            this.joinForm.name = '';
            this.joinForm.mobile = '';
            this.joinForm.companyName = '';
            this.joinForm.regionArray = [];
            this.joinForm.region = '';
          }).catch(err => {
            this.$message.error('提交失败，请稍后重试');
            console.error(err);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.parlor-page {
  width: 100%;
  background-color: #fff;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 1080px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/parlor-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  color: #fff;

  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 345px;

    h1 {
      font-weight: bold;
      font-size: 78px;
      line-height: 92px;
      margin-bottom: 30px;
    }

    p {
      font-size: 17px;
      font-weight: bold;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      line-height: 25px;
      margin-bottom: 70px;
      max-width: 700px;
    }

    .actions {
      display: flex;

      .btn-yellow {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #0F0FB1;
        width: 150px;
        height: 50px;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
      }

      .btn-dark {
        background-color: #002366;
        border-color: #002366;
        color: #fff;
        width: 50px;
        height: 50px;
        margin-left: -5px;
      }
    }
  }
}

// 资源展示区域
.resource-showcase {
  width: 1200px;
  margin: 80px auto;

  .tab-container {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;

    .tab {
      font-size: 20px;
      color: #999;
      padding: 0 20px;
      cursor: pointer;
      position: relative;

      &.active {
        color: #ffc107;
        font-weight: bold;

        &:after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 30px;
          height: 4px;
          background-color: #ffc107;
        }
      }
    }
  }

  .resources-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 30px;

    .resource-item {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

      .resource-image {
        width: 100%;
        height: 240px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .resource-info {
        padding: 20px;

        h3 {
          font-weight: bold;
          font-size: 28px;
          color: #19456B;
          line-height: 36px;
          margin-bottom: 15px;
        }

        .resource-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .resource-tags {
            display: flex;
            align-items: center;

            span {
              display: inline-block;
              font-size: 17px;
              color: #382933;
              line-height: 25px;
              margin-right: 15px;

              &.location {
                font-size: 12px;
                color: #0F0FB1;
                line-height: 25px;
                background: #F3F3FF;
                padding: 2px 8px;
              }
            }
          }

          .resource-action {
            .btn-detail {
              font-size: 18px;
              color: #19456B;
              line-height: 24px;
              padding: 6px 12px;
              background-color: #ffc107;
              border-color: #ffc107;
            }
          }
        }
      }
    }
  }
}

// 会员加入部分
.section-join {
  margin: 0 auto 100px;
  width: 100%;
  height: 680px;
  box-sizing: border-box;
  padding: 40px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/parlor-bg2.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  .join-content {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1200px;

    h2 {
      font-weight: 500;
      font-size: 42px;
      color: #FFFFFF;
      line-height: 52px;
      text-align: center;
      margin-bottom: 40px;
    }

    .join-form {
      width: 500px;

      .el-input,
      .el-cascader {
        width: 100%;
        display: block;
        margin-bottom: 25px;

        ::v-deep .el-input__inner {
          background-color: #FFFFFF;
          border: none;
          border-radius: 10px;
          height: 50px;
          padding: 0 20px;
          font-size: 18px;
          color: #333333;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

          &::placeholder {
            color: #999999;
          }
        }
      }

      .submit-btn {
        width: 100%;
        height: 50px;
        background-color: #FFC107;
        border-color: #FFC107;
        border-radius: 10px;
        font-size: 20px;
        font-weight: 500;
        color: #333;
        margin-top: 10px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

        &:hover, &:focus {
          background-color: #ffca2c;
          border-color: #ffca2c;
        }
      }
    }
  }
}

// 添加分页样式
.pagination {
  margin-top: 40px;
  text-align: center;
  padding-bottom: 40px;
}
</style>